import { render, staticRenderFns } from "./BookingEventDetails.vue?vue&type=template&id=5df0d402&scoped=true&"
import script from "./BookingEventDetails.vue?vue&type=script&lang=ts&"
export * from "./BookingEventDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BookingEventDetails.vue?vue&type=style&index=0&id=5df0d402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df0d402",
  null
  
)

export default component.exports